import { P } from 'components'
import { ResponsiveActionButton } from 'components/Buttons'
import PMBBadge from 'components/PMBBadge'
import { TableComponent as DataTable } from 'components/TableComponent'
import { capitalizeEveryWord } from 'helpers'
import { ChevronDown } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardBody, Col, Row, Spinner } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION } from 'utils/pathUrl'
import {
  resetDisbursementByEmployeeId,
  setEmployeeEdit,
  setIsOpenModalManual,
} from './employeePaymentsListSlice'
import CustomButton from 'components/Buttons/CustomButton'

const TabDisbursement = ({ isLoading, isFetching }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { disbursementData } = useSelector(
    (state) => state.employeePaymentsList,
  )
  const disburses = disbursementData?.disburses || []

  const columns = [
    {
      name: <span>Name</span>,
      wrap: true,
      grow: 2,
      cell: (row) => row?.employeeName || '',
    },
    {
      name: <span>Role</span>,
      wrap: true,
      grow: 2,
      cell: (row) => row?.rolesName || '',
    },
    {
      name: <span>Amount</span>,
      wrap: true,
      grow: 2,
      right: true,
      cell: (row) => {
        return <div>Rp{newFormatThousandSeparator(row?.amount)}</div>
      },
    },
    {
      name: <span>Payment Method</span>,
      wrap: true,
      grow: 2,
      center: true,
      cell: (row) => {
        const status = row?.disburseMethod
        return (
          <>
            {status && (
              <PMBBadge
                variant={
                  status === 'BANK_TRANSFER'
                    ? 'warning'
                    : status === 'CASH'
                      ? 'verify'
                      : 'danger'
                }
                title={capitalizeEveryWord(row?.disburseMethod)}
                className="px-2 w-auto"
                size="small"
              />
            )}
          </>
        )
      },
    },
    {
      name: <span>Note</span>,
      wrap: true,
      grow: 2,
      cell: (row) => row?.notes || '',
    },
    {
      name: '',
      wrap: true,
      width: '100px',
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center justify-content-end">
          {row?.amount > 0 ? (
            <div className="d-flex align-items-center  gap-2">
              <ResponsiveActionButton
                iconName="pencil"
                label="Edit"
                onClick={() => {
                  dispatch(setEmployeeEdit(row))
                  dispatch(setIsOpenModalManual(true))
                }}
              />
              <ResponsiveActionButton
                key="delete"
                iconName="trash"
                label="Clear"
                onClick={() => {
                  dispatch(resetDisbursementByEmployeeId(row?.employeeUserId))
                }}
              />
            </div>
          ) : (
            <ResponsiveActionButton
              iconName="plus-circle-outline"
              label="Add Manual"
              onClick={() => {
                dispatch(setEmployeeEdit(row))
                dispatch(setIsOpenModalManual(true))
              }}
            />
          )}
        </div>
      ),
    },
  ]

  return (
    <>
      {/* HEADER SECTION */}
      <Row className="mb-4 align-items-center g-3">
        <Col xs="12" md="7" lg="8">
          <div className="d-flex flex-column">
            <h6 className="mb-1 fw-bold" style={{ fontSize: '20px', letterSpacing: '-0.3px' }}>
              Employee Disbursement
            </h6>
            <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
              Select employees and configure payment details
            </p>
          </div>
        </Col>
        <Col xs="12" md="5" lg="4" className="text-md-end">
          <CustomButton
            color="primary"
            className="w-100 w-md-auto px-4"
            style={{ 
              height: '42px', 
              borderRadius: '10px',
              fontWeight: 600
            }}
            onClick={() => navigate(URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION)}
          >
            Auto Calculate
          </CustomButton>
        </Col>
      </Row>

      <Card className="border-0 shadow-none">
        <CardBody>
          <P className="mb-2" size="medium">
            Available Employees
          </P>
          <div>
            <DataTable
              columns={columns}
              data={disburses}
              pagination
              paginationServer
              sortServer
              responsive
              persistTableHead
              progressPending={isLoading}
              progressComponent={
                <div style={{ margin: '100px 0px' }}>
                  <Spinner color="primary" />
                </div>
              }
              className="border p-0 border-1 rounded-top"
              noDataComponent={
                <p className="my-3 fw-semibold">
                  {!isLoading && !isFetching
                    ? 'Belum ada data yang didaftarkan'
                    : 'Belum ada daftar perjalanan yang didaftarkan.'}
                </p>
              }
              sortIcon={<ChevronDown />}
              paginationComponent={(props) => <></>}
            />
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default TabDisbursement
